module.exports = __webpack_public_path__ + "img/idcard_back.3ca49ac7.png";